import React, { useCallback, useMemo, useReducer } from 'react';

import notificationConstants    from './notification.constants';
import NotificationContext      from './notification.context';
import notificationReducer      from './notification.reducer';
import notificationInitialState from './notification.state';

/**
 * @type {React.FC}
 */

const NotificationProvider = function({
  children,
  value = notificationInitialState,
}) {
  const [state, dispatch] = useReducer(notificationReducer, value);

  const hideModal = useCallback(() => {
    dispatch({ type: notificationConstants.HIDE_MODAL });
  }, [dispatch]);
  const showModal = useCallback((title, description) => {
    dispatch({
      type: notificationConstants.SHOW_MODAL,
      title,
      description,
    });
  }, [dispatch]);

  const context = useMemo(() => (
    {
      ...state,
      hideModal,
      showModal,
    }), [hideModal, showModal, state]);

  return (
    <NotificationContext.Provider value={context}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;